import { useRef, useState } from 'react';
import { useElementSize } from '@/hooks/useElementSize';
import ChevronDownIcon from '/public/icons/chevron-down.svg';
import CheckCircleIcon from '/public/icons/check-circle-2.svg';

interface PassengerItemWrapperProps {
  header?: string;
  children?: React.ReactNode;
  index?: number;
  isValid?: boolean;
}

export const PassengerItemWrapper = ({ header = '', index = 1, children, isValid = false }: PassengerItemWrapperProps) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const { height } = useElementSize<HTMLDivElement>(ref);
  return (
    <div className="border border-blue-100 rounded-lg overflow-hidden bg-white">
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center px-6 py-6 justify-between focus:outline-none cursor-pointer "
      >
        <div className="flex items-center gap-5">
          <h4 className="!font-inter text-blue-900 h-[44px] w-[44px] flex items-center justify-center bg-grey-100 border border-grey-200 rounded-full">
            {index}
          </h4>
          <h3 className="light text-blue-900">{header}</h3>
        </div>
        <div className="flex items-center gap-3">
          {isValid && <CheckCircleIcon className="w-6 h-6" />}
          <span className={`transform transition-transform duration-200 ease-in-out ${open ? 'rotate-180' : 'rotate-0'}`}>
            <ChevronDownIcon className="w-3 h-3 fill-current text-blue-900 !stroke-[1.2px] !stroke-current" />
          </span>
        </div>
      </button>
      <div
        ref={ref}
        className={`transition-max-height duration-300 ease-in-out overflow-hidden ${
          open ? `max-h-[${height}px]` : 'max-h-0'
        }`}
      >
        {open && <div className="mx-6 h-[1px] bg-blue-100" />}
        {open && children}
      </div>
    </div>
  );
};
